import '../style.css';
import Library from '../lib/Library.js';
import {Map} from '../lib/Map.js';
import {BaseLayer} from '../lib/BaseLayer.js';
import {MapLayer} from '../lib/MapLayer.js';
import {AirepLayer} from '../lib/layers/Airep.js';
import {AirportLayer} from '../lib/layers/Airport.js';
import {AirmetLayer} from '../lib/layers/Airmet.js';
import {CwaLayer} from '../lib/layers/Cwa.js';
import {FeatureLayer} from '../lib/layers/Feature.js';
import {FixLayer} from '../lib/layers/Fix.js';
import {FltCatLayer} from '../lib/layers/FltCat.js';
import {FltPathLayer} from '../lib/layers/FltPath.js';
import {FrontLayer} from '../lib/layers/Front.js';
import {GairmetLayer} from '../lib/layers/Gairmet.js';
import {MetarTafLayer} from '../lib/composite/MetarTaf.js';
import {MisLayer} from '../lib/layers/Mis.js';
import {NavaidLayer} from '../lib/layers/Navaid.js';
import {HazardLayer} from '../lib/layers/Hazard.js';
import {ObstacleLayer} from '../lib/layers/Obstacle.js';
import {RadarsLayer} from '../lib/composite/Radars.js';
import {SatelliteLayer} from '../lib/layers/Satellite.js';
import {SigmetLayer} from '../lib/layers/Sigmet.js';
import {TcfLayer} from '../lib/layers/Tcf.js';
import {WeatherLayer} from '../lib/layers/Weather.js';
import {MousePosition} from '../lib/controls/MousePosition.js';
import {ScaleLine} from '../lib/controls/ScaleLine.js';
import {FullScreen} from '../lib/controls/FullScreen.js';
import {DateLabel} from '../lib/controls/DateLabel.js';
import {TimeSlider} from '../lib/controls/TimeSlider.js';
import {LevelSlider} from '../lib/controls/LevelSlider.js';
import {RotateReset} from '../lib/controls/RotateReset.js';

function init(){
    let map = new Map();
    map.addLayer( new BaseLayer( map, {"type": "globe_light"} ));
    map.addLayer( new MapLayer( map, {"type": "city"} ));
    map.addLayer( new SatelliteLayer( map, {"visible": true} ));
    map.addLayer( new WeatherLayer( map ));
    map.addLayer( new RadarsLayer( map, {"visible": true, "looping": true, "label_target": "label_radar"} ));
    map.addLayer( new MapLayer( map, {"type": "basic", "visible": true } ));
    map.addLayer( new MapLayer( map, {"type": "latlon"} ));
    map.addLayer( new MapLayer( map, {"type": "river"} ));
    map.addLayer( new MapLayer( map, {"type": "county"} ));
    map.addLayer( new MapLayer( map, {"type": "river"} ));
    map.addLayer( new MapLayer( map, {"type": "cwarn"} ));
    map.addLayer( new MapLayer( map, {"type": "rail"} ));
    map.addLayer( new MapLayer( map, {"type": "road"} ));
    map.addLayer( new MapLayer( map, {"type": "highway"} ));
    map.addLayer( new MapLayer( map, {"type": "jetroute"} ));
    map.addLayer( new MapLayer( map, {"type": "qroute"} ));
    map.addLayer( new MapLayer( map, {"type": "airway"} ));
    map.addLayer( new MapLayer( map, {"type": "airspace"} ));
    map.addLayer( new MapLayer( map, {"type": "sua"} ));
    map.addLayer( new MapLayer( map, {"type": "runway"} ));
    map.addLayer( new MapLayer( map, {"type": "fir"} ));

    map.addLayer( new FrontLayer( map ));
    map.addLayer( new AirmetLayer( map ));
    map.addLayer( new GairmetLayer( map ));
    map.addLayer( new HazardLayer( map ));
    map.addLayer( new NavaidLayer( map ));
    map.addLayer( new FixLayer( map ));
    map.addLayer( new ObstacleLayer( map ));
    map.addLayer( new FeatureLayer( map ));
    map.addLayer( new AirportLayer( map ));
    map.addLayer( new CwaLayer( map ));
    map.addLayer( new MisLayer( map ));
    map.addLayer( new SigmetLayer( map, {"visible": true} ));
    map.addLayer( new TcfLayer( map ));
    map.addLayer( new AirepLayer( map, {"visible": true} ));
    map.addLayer( new FltCatLayer( map ));
    map.addLayer( new MetarTafLayer( map, {"visible": true} ));
    map.addLayer( new FltPathLayer( map ));
    
    map.addControl( new MousePosition( map ));
    map.addControl( new ScaleLine( map ));
    map.addControl( new FullScreen( map ));
    map.addControl( new DateLabel( map ));
    map.addControl( new RotateReset( map ));
    map.addControl( new TimeSlider( map, { 
                "min": -12,
                "max": 18,
                "value": 0,
                "onchange": function( val, date ){
                    console.info( 'slider', val, date );
                }
                } ));
    map.addControl( new LevelSlider( map, { 
                "levels": [ "sfc", "030", "060", "090", "120", "150", 
                "180", "210", "240", "270", "300", "360", "420", "480", 
                "all" ],
                "value": 0,
                "onchange": function( val, level ){
                    console.info( 'slider', val, level );
                    
                }
                } ));
    map.setupInput();
    map.setLocation();
    map.setTimeout();

    window.map = map;
}

document.addEventListener("DOMContentLoaded", 
    function() {
        init();
        }
    );

